import { render, staticRenderFns } from "./InventoryFilter.vue?vue&type=template&id=4a3719d0&"
import script from "./InventoryFilter.vue?vue&type=script&lang=js&"
export * from "./InventoryFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports